// Module
var code = `<div ng-show="headline || prompt" class="grid auto-rows-auto grid-cols-1 mb-6"> <h5 ng-show="headline" class="col-span-1" translate>{{ headline }}</h5> <p ng-show="prompt" class="col-span-1" translate>{{ prompt }}</p> </div> `;
// Exports
export default code;